import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { B3SelectItem } from 'src/app/shared/models/b3-select-item.model';
import { startWith } from 'rxjs';
import {
  findPsaSelectItemById,
  resolvePsaSelectItemId,
} from 'src/app/helpers/utils/psa-baseline-methodology.util';
import { FORM_REGISTER } from 'src/app/pages/projects-repository/register/project/project-register.component';
import { ProjectMethodologiesService } from 'src/app/pages/projects-repository/services/project-methodology.service';
import { PsaProjectData } from 'src/app/shared/interfaces/psa-project-register';

@Component({
  standalone: false,
  selector: 'app-psa-step-methodology',
  templateUrl: './step-methodology.component.html',
  styleUrls: ['./step-methodology.component.scss']
})
export class PsaStepMethodologyComponent implements OnInit {
  public today = new Date();
  public maxDate: Date;
  public minDate: Date;
  public errorMsg = "Data inválida ou não preenchida";

  characterCountRA: number = 0;
  characterCountDocument: number = 0;

  date: boolean = true;
  isInvalidDate: boolean = false;

  selectMethodology: B3SelectItem[] = [];
  public methodologies: any[] = [];

  constructor(
    @Inject(FORM_REGISTER) public formRegister: FormGroup,
    @Inject('projectDraftData') public projectDraftData: PsaProjectData,
    private projectMethodologiesService: ProjectMethodologiesService,
  ) {
    const currentYear = new Date().getFullYear();
    this.maxDate = new Date(currentYear, 11, 31);
    this.minDate = new Date(1992, 0, 1);
  }

  ngOnInit(): void {
    this.loadMethodologies();

    this.formRegister.get('ramComplianceReportDetail')?.valueChanges
      .pipe(
        startWith(this.formRegister.get('ramComplianceReportDetail')?.value || '')
      )
      .subscribe(value => {
        this.characterCountRA = value ? value.length : 0;
      });

    this.formRegister.get('documentDescription')?.valueChanges
      .pipe(
        startWith(this.formRegister.get('documentDescription')?.value || '')
      )
      .subscribe(value => {
        this.characterCountDocument = value ? value.length : 0;
      });
  }

  loadFormRegister(): void {
    this.applyMethodologyFromDraft();
  }

  onBlurDate(date: Date, inputId: string) {
    this.formRegister.get(inputId)?.setValue(date);
    this.date = false;
    this.isInvalidDate = date > this.today || date < this.minDate;
  }

  public checkHasError(fieldName: string, errorCode?: string): boolean {
    let field = this.formRegister.get(fieldName);
    if (field == null || !field.touched) {
      return false;
    }
    if (errorCode == null) {

      return field.invalid;
    }
    return field.hasError(errorCode);
  }

  isRamLinkMissing(): boolean {
    const field = this.formRegister.get('ramComplianceReportLink');
    if (!field?.touched) {
      return false;
    }

    return !String(field.value ?? '').trim();
  }

  isRamLinkInvalid(): boolean {
    const field = this.formRegister.get('ramComplianceReportLink');
    const value = String(field?.value ?? '').trim();
    if (!value || !field?.touched) {
      return false;
    }

    const candidate = /^(https?:\/\/)/i.test(value) ? value : `https://${value}`;
    try {
      const parsed = new URL(candidate);
      return !(parsed.hostname && parsed.hostname.includes('.'));
    } catch {
      return true;
    }
  }

  public loadMethodologies(): void {
    this.projectMethodologiesService.getMethodologies().subscribe(response => {
      const methodologies: any[] = response?.data ?? [];

      this.selectMethodology = methodologies.map(methodology => ({
        inputId: methodology.methodologyIdentifier,
        label: methodology.methodologyDescription,
        data: methodology.methodologyIdentifier
      }));

      this.applyMethodologyFromDraft();
    });
  }

  private resolveMethodologyValue(): B3SelectItem | '' {
    if (!this.selectMethodology.length) {
      return '';
    }

    const currentMethodologyId = resolvePsaSelectItemId(this.formRegister.get('methodology')?.value);
    if (currentMethodologyId != null) {
      const fromForm = findPsaSelectItemById(this.selectMethodology, currentMethodologyId);
      if (fromForm) {
        return fromForm;
      }
    }

    const draftId = this.projectDraftData?.methodologyId;
    if (draftId != null) {
      const fromDraft = findPsaSelectItemById(this.selectMethodology, draftId);
      if (fromDraft) {
        return fromDraft;
      }
    }

    return '';
  }

  private applyMethodologyFromDraft(): void {
    const resolved = this.resolveMethodologyValue();
    if (!resolved) {
      return;
    }

    const control = this.formRegister.get('methodology');
    control?.setValue(resolved);
    // Re-apply after projected select options render for the DS web component.
    setTimeout(() => {
      control?.setValue(resolved);
      control?.markAsPristine();
      control?.markAsUntouched();
    });
  }
}